import {Component, OnDestroy, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {JhiAlertService, JhiEventManager, JhiParseLinks} from 'ng-jhipster';
import {
  ActivitySetting,
  IActivitySetting,
  IFormChildList,
} from '@entities/activity/activity.model';
import {ActivityService} from '@entities/activity/activity.service';

@Component({
  selector: 'app-activity-type-detail',
  templateUrl: './activity-type-detail.component.html',
  styleUrls: ['./activity-type-detail.component.scss'],
})
export class ActivityTypeDetailComponent implements OnInit, OnDestroy {
  activitySetting: IActivitySetting;
  extendFormChild: IFormChildList[];
  controlType: any;
  optionUnit: any;
  constructor(
    private activityService: ActivityService,
    private alertService: JhiAlertService,
    private eventManager: JhiEventManager,
    private parseLinks: JhiParseLinks,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private translate: TranslateService,
  ) {
    this.activitySetting = new ActivitySetting();
    this.extendFormChild = [];
    this.controlType = [];
    this.optionUnit = [];
  }
  ngOnInit() {
    this.titleService.setTitle(
      this.translate.instant('entities.activity.activityType.detail'),
    );
  }
  ngOnDestroy() {}
}
